import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { FaTimes } from "react-icons/fa";
import { getPriorityStyle, getStatusStyle } from "./TicketDetailModal";

const Field = ({ label, value }) => {
  if (!value) return null;
  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: "var(--color-text-light)", textTransform: "uppercase", marginBottom: 4 }}>
        {label}
      </div>
      <div style={{ fontSize: 14, color: "var(--color-text)" }}>{value}</div>
    </div>
  );
};

const FreshserviceTicketModal = ({ ticket, onClose }) => {
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const prevHtml = html.style.overflow;
    const prevBody = body.style.overflow;
    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
    return () => {
      html.style.overflow = prevHtml;
      body.style.overflow = prevBody;
    };
  }, []);

  useEffect(() => {
    const handleKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [onClose]);

  if (!ticket) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.15 }}
      onClick={onClose}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.95, y: 16 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.95, y: 16 }}
        transition={{ duration: 0.2 }}
        onClick={(e) => e.stopPropagation()}
        style={{ background: "var(--color-bg-card)", borderRadius: 16, boxShadow: "0 20px 60px rgba(0,0,0,0.4)", border: "1px solid var(--color-border)", width: "100%", maxWidth: 560, maxHeight: "85vh", overflowY: "auto" }}
      >
        {/* Header */}
        <div style={{ padding: "20px 24px", borderBottom: "1px solid var(--color-border)", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
              <span style={{ fontSize: 11, fontWeight: 700, background: "rgba(99,102,241,0.15)", color: "#6366f1", padding: "2px 8px", borderRadius: 6, textTransform: "uppercase", letterSpacing: 0.5 }}>
                Freshservice
              </span>
              <span style={{ fontSize: 13, fontWeight: 700, color: "#6366f1" }}>
                {ticket.ticket_number}
              </span>
            </div>
            <h6 style={{ margin: 0, fontSize: 15, fontWeight: 600, color: "var(--color-text)", lineHeight: 1.4, wordBreak: "break-word" }}>
              {ticket.title || "No Title"}
            </h6>
          </div>
          <button
            onClick={onClose}
            style={{ background: "none", border: "none", cursor: "pointer", padding: 4, color: "var(--color-text-light)", flexShrink: 0, marginTop: 2 }}
          >
            <FaTimes size={16} />
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: "20px 24px" }}>
          {/* Status + Priority row */}
          <div style={{ display: "flex", gap: 24, marginBottom: 20, flexWrap: "wrap" }}>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--color-text-light)", textTransform: "uppercase", marginBottom: 6 }}>Status</div>
              <span style={{ ...getStatusStyle(ticket.status), padding: "4px 12px", borderRadius: 12 }}>{ticket.status || "Unknown"}</span>
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--color-text-light)", textTransform: "uppercase", marginBottom: 6 }}>Priority</div>
              <span style={{ ...getPriorityStyle(ticket.priority), padding: "4px 12px", borderRadius: 12 }}>{ticket.priority || "Unknown"}</span>
            </div>
          </div>

          <Field label="Queue / Category" value={ticket.queue_category} />
          <Field label="Requester" value={ticket.requester} />
          <Field label="Assignee" value={ticket.assignee} />
          <Field label="Created" value={ticket.created_date ? new Date(ticket.created_date).toLocaleString() : ticket.created} />
        </div>
      </motion.div>
    </motion.div>
  );
};

export default FreshserviceTicketModal;
